import React, { useState } from 'react'
import { Input } from 'antd'
import { v4 as uuidv4 } from 'uuid'

const InputWithoutAutoComplete = ({ autoFocus = false, ...props }) => {
  const [readOnly, setReadOnly] = useState(true)

  return (
    <Input
      {...props}
      autoComplete={`noAutoComplete-${uuidv4()}`}
      readOnly={readOnly}
      onFocus={() => setReadOnly(false)}
      onTouchStart={() => setReadOnly(false)}
      onBlur={() => setReadOnly(true)}
      autoFocus={autoFocus}
    />
  )
}

export default InputWithoutAutoComplete
